import React from 'react';

import IString from '../../common/components/i-string';

function VerificationComplete() {
  return (
    <>
      <h2 className='formTitle'>
        <IString stringKey='complete.title' />
      </h2>
      <div className='formish'>
        <p>
          <IString stringKey='complete.message' />
        </p>
      </div>
    </>
  );
}

export default VerificationComplete;
